// extracted by mini-css-extract-plugin
export default {"courseBg":"courseClass_courseBg__17tlL","courseInfo":"courseClass_courseInfo__zcvlD","price":"courseClass_price__EVqOb"};